import React from 'react';
import { useTheme } from '@mui/material/styles';
import { lighten } from '@mui/material/styles';
import { LinearProgress as MuiLinearProgress } from '@mui/material';

export const sx = () => {
  const theme = useTheme();

  return {
    height: 15,
    borderRadius: theme.shape.borderRadius * 2,
    '& .MuiLinearProgress-bar': {
      borderRadius: theme.shape.borderRadius * 2,
    },
    '&.MuiLinearProgress-colorSecondary': {
      backgroundColor: lighten(theme.palette.secondary.main, theme.palette.tonalOffset.light),
    },
  };
};

const LinearProgress = React.forwardRef((props: any, ref: any) => {
  return <MuiLinearProgress ref={ref} color="secondary" variant="determinate" sx={sx} {...props} />;
});

LinearProgress.displayName = 'LinearProgress';

export default LinearProgress;
